import { render, staticRenderFns } from "./PackagePeriodOrderDetail.vue?vue&type=template&id=b8ea9cea&scoped=true&"
import script from "./PackagePeriodOrderDetail.vue?vue&type=script&lang=js&"
export * from "./PackagePeriodOrderDetail.vue?vue&type=script&lang=js&"
import style0 from "./PackagePeriodOrderDetail.vue?vue&type=style&index=0&id=b8ea9cea&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8ea9cea",
  null
  
)

export default component.exports